import { UserLoginAction } from "../actions/UserLoginAction";
import { UserCluster } from "../models/UserCluster";
import { UserCompany } from "../models/UserCompany";
//import { Role } from "../models/UserRole";
import { Common } from "../utils/Common";

export interface UserLoginState {
  sapSystem: string;
  userName: string;
  email: string;
  refreshToken: string;
  accessToken: string;
  isAuthenticated: boolean;
  isVendor: boolean;
  //roles: number[];
  errorMessage: string;
  //appPointIds: number[];
  userCompanies: UserCompany[];
  userClusters: UserCluster[];
}

const initialState = {
  sapSystem:"",
  userName: "",
  email: "",
  refreshToken: "",
  accessToken: "",
  isAuthenticated: false,
  isVendor: false,
  //roles: [],
  errorMessage: "",
  //appPointIds: [],
  userCompanies:[],
  userClusters:[]
};

function getInitiatState() {
  if (Common.getLoginUserData()) {
    let logUser: UserLoginState = JSON.parse(Common.getLoginUserData()!);
    return logUser;
  } else {
    return initialState;
  }
}

export function LoginReducer(
  state: UserLoginState = getInitiatState(),
  action: UserLoginAction
): UserLoginState {
  switch (action.type) {
    case "USER_AUTH_SUCCESS":
      //sucees call back of login request
      return {
        ...state,
        sapSystem: action.payload.sapSystem,
        userName: action.payload.userName,
        email: action.payload.email,
        refreshToken: action.payload.refreshToken,
        accessToken: action.payload.accessToken,
        isAuthenticated: true,
        isVendor: action.payload.isVendor,
        //roles: action.payload.roles,
        errorMessage: "",
        //appPointIds: action.payload.appPointIds,
        userCompanies: action.payload.userCompanies,
        userClusters: action.payload.userClusters
      };
    default:
      return state;
  }
}
